import { useState } from 'react'
import { Row, Col, Card, Select, Divider } from 'antd'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import PropertyMapper from './PropertyMapper'
import Form from '$components/Form'

const FormHeader = styled.h2`
  font-size: 1.2em;
  font-weight: 500;

  margin: 20px 0;
`

const MappingForm = ({
  name = 'mapDataForm',
  internalProperties,
  propertiesToMap,
  handleOk,
  data,
  groups = [],
  activeGroup,
}) => {
  const { t } = useTranslation()
  const [mappedProperties, setMappedProperties] = useState([])
  const [numberSeparator, setNumberSeparator] = useState('point_decimal')
  const initialGroupValues = (activeGroup) => {
    return activeGroup === '1' ? undefined : activeGroup
  }

  return (
    <>
      <Card>{t('parts_master_data.upload.mapping_prompt')}</Card>

      <Form
        initialValues={{
          number_separator: 'point_decimal',
          group: { value: initialGroupValues(activeGroup) },
        }}
        onFinish={handleOk}
        name={name}
        labelAlign="left"
        labelCol={{ span: 10 }}
        requiredMark={false}
        onValuesChange={(changedValues, allValues) => {
          if (changedValues.number_separator) {
            setNumberSeparator(changedValues.number_separator)
          }

          setMappedProperties(
            Object.entries(allValues)
              .filter(([key, _]) => !key.endsWith('-unit'))
              .map(([_, val]) => val)
              .filter((val) => val !== undefined && val !== null),
          )
        }}
      >
        <Form.Item
          name="number_separator"
          label={t('parts_master_data.upload.number_format_label')}
          style={{ margin: '16px 0' }}
          rules={[
            {
              required: true,
              message: t('parts_master_data.upload.required_field_prompt'),
            },
          ]}
        >
          <Select
            placeholder={t('parts_master_data.upload.select_placeholder')}
            allowClear={true}
          >
            <Select.Option value="point_decimal">
              {t('parts_master_data.upload.point_as_decimal_option')}
            </Select.Option>
            <Select.Option value="comma_decimal">
              {t('parts_master_data.upload.comma_as_decimal_option')}
            </Select.Option>
          </Select>
        </Form.Item>

        <Divider style={{ margin: '8px 0 0' }} />

        <Row>
          <Col span={10}>
            <FormHeader>
              {t('parts_master_data.upload.required_fields')}
            </FormHeader>
          </Col>
          <Col span={14}>
            <FormHeader>
              {t('parts_master_data.upload.mapping_column_header')}
            </FormHeader>
          </Col>
        </Row>

        {internalProperties
          .filter((property) => property.required)
          .map((property) => (
            <PropertyMapper
              key={property.name}
              propertiesToMap={propertiesToMap}
              disableOptions={mappedProperties}
              numberSeparator={numberSeparator}
              data={data}
              {...property}
            />
          ))}

        <Row>
          <Col span={10}>
            <FormHeader>
              {t('parts_master_data.upload.optional_fields')}
            </FormHeader>
          </Col>
          <Col span={14}>
            <FormHeader>
              {t('parts_master_data.upload.mapping_column_header')}
            </FormHeader>
          </Col>
        </Row>

        {internalProperties
          .filter((property) => !property.required)
          .map((property) => (
            <PropertyMapper
              key={property.name}
              propertiesToMap={propertiesToMap}
              disableOptions={mappedProperties}
              numberSeparator={numberSeparator}
              data={data}
              {...property}
            />
          ))}

        {groups.length > 0 ? (
          <>
            <Row>
              <Col span={10}>
                <FormHeader>
                  {t('parts_master_data.create.to_group')}
                </FormHeader>
              </Col>
              <Col span={14}></Col>
            </Row>

            <Form.Item
              label={t('parts_master_data.create.assign_group')}
              name="group"
            >
              <Select
                className="property-select"
                placeholder={t(
                  'parts_master_data.create.select_group_placeholder',
                )}
                allowClear={true}
                options={groups.map((item) => {
                  return {
                    value: item.id,
                    label: item.list_name,
                  }
                })}
              />
            </Form.Item>
          </>
        ) : null}
      </Form>
    </>
  )
}

export default MappingForm
